import { trackRudderstackEvent } from '../libs/rudderstack';

export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  trackRudderstackEvent(eventName, properties);
}
